import {ITabComponent} from "./PublicationViewPageInternal";

export const PublicationFiles = ({model}: ITabComponent) => {
    return null;
}